/**
 * DeviceAlarmWarning — the note shown when a device action goes ahead while the device is
 * in alarm (docs/ACTIVE_ALARM_GATING.md). Those actions were blocked in 4.3.9; a device
 * that breaks while alarming could then never be removed, so they now proceed with this
 * warning instead. Renders nothing when `show` is false.
 *
 *   <DeviceAlarmWarning show={isAlarming(device)} />
 *
 * @param {boolean} show
 * @param {string} [message] — DEVICE_ALARM_WARNING_MSG unless a site needs its own words
 * @param {boolean} [compact] — smaller type, for a note under a row in a list
 */

import { DEVICE_ALARM_WARNING_MSG } from '../../utils/activeAlerts.js';
import './device-alarm-warning.css';

const DeviceAlarmWarning = ({ show, message = DEVICE_ALARM_WARNING_MSG, compact = false }) => {
  if (!show) return null;
  return (
    <div className={`device-alarm-warning${compact ? ' device-alarm-warning--compact' : ''}`} role="note">
      <svg className="device-alarm-warning__icon" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
      </svg>
      <span>{message}</span>
    </div>
  );
};

export default DeviceAlarmWarning;
